<template>
  <div class="w-full">
    <div class="pb-4">
      <div class="text-xl w-full font-medium mb-3 truncate text">{{ title }}</div>
      <div class="flex items-center w-full">
        <div class="w-10 h-10 rounded-full overflow-hidden">
          <img :src="avator" class="w-full h-full" />
        </div>
        <span class="ml-2 font-medium text">{{ nickname }}</span>
      </div>
    </div>
    <div class="hr"></div>
  </div>
</template>
<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class ScreenshotUserInfo extends Vue {
  @Prop({ type: String }) title: string;
  @Prop({ type: String }) avator: string;
  @Prop({ type: String }) nickname: string;
}
</script>
<style scoped>
.text {
color: #1A051D;
}
.hr {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

</style>
